import styled from 'styled-components'

export const Container = styled.div`
  .fs-medium {
    font-size: 1.5rem;
  }
`
